import React from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

const Nothing = ({ visible, className }) => {
	const cls = classnames(
		'py-6 px-4 flex flex-col justify-center items-center text-lg text-neutral-300 dark:text-neutral-600 transition-colors',
		className
	);

	return (
		<Show if={visible}>
			<div className={cls}>
				<Icon icon="sentiment_neutral" className="text-3xl" />
				Nekas netika atrasts!
			</div>
		</Show>
	);
};

export default Nothing;